module.exports = __webpack_public_path__ + "static/media/blog7.68d5c430.jpg";